import { render, staticRenderFns } from "./VIPHome.vue?vue&type=template&id=445bd587&"
import script from "./VIPHome.vue?vue&type=script&lang=js&"
export * from "./VIPHome.vue?vue&type=script&lang=js&"
import style0 from "./VIPHome.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports